import ResetPassword from "./ResetPassword";
export { ResetPassword };
